'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _PubNubMessageRecord = require('conversations-schema/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _ChatHistory = require('conversations-schema/records/ChatHistory');

var _ChatHistory2 = _interopRequireDefault(_ChatHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  endedAt: null,
  channel: null,
  latestMessage: (0, _PubNubMessageRecord2.default)(),
  messagesUtk: null,
  portalId: null,
  startedAt: null,
  status: null,
  url: null,
  userId: null,
  vid: null,
  chatHistory: (0, _ChatHistory2.default)(),
  unseenCount: 0
}, 'Conversation');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/Conversation.js
// module id = 31
// module chunks = 0 1